import { Link } from "react-router-dom";
import type { Film } from "@/types/content";
import Tag from "@/components/base/Tag";
import { formatViews } from "@/utils/format";

interface FilmCardProps {
  film: Film;
}

export default function FilmCard({ film }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] bg-background-200 overflow-hidden">
        <img
          src={film.cover}
          alt={`夜勤病栋影视作品海报：${film.title}`}
          title={`${film.title} - 夜勤病栋影视`}
          className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded bg-primary-800/90 text-background-50 text-[11px] tracking-wide backdrop-blur-sm">
          {film.type}
        </span>
        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded bg-accent-500 text-background-50 text-[11px] font-medium">
          {film.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-foreground-950/85 to-transparent"></div>
        <div className="absolute bottom-2 left-2 right-2 flex items-center gap-2 text-[11px] text-background-100">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line"></i>
            {formatViews(film.views)}
          </span>
          <span className="text-background-300">·</span>
          <span>{film.region}</span>
          <span className="text-background-300">·</span>
          <span>{film.year}</span>
        </div>
      </div>

      <div className="flex flex-col p-3 md:p-3.5 flex-1">
        <h3 className="font-heading font-semibold text-sm md:text-[15px] text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
          {film.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed flex-1">
          {film.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {film.genres.slice(0, 3).map((genre) => (
            <Tag key={genre} label={genre} />
          ))}
        </div>
      </div>
    </Link>
  );
}